import { Dispatch } from 'redux';
import { IState } from '../../../reducers';
import config from '../../../config';
import {
    EDIT_EMAIL, RESET, VERIFY_SPECIAL_ACCESS_FAILURE, VERIFY_SPECIAL_ACCESS_REQUEST, VERIFY_SPECIAL_ACCESS_SUCCESS,
} from './contants';
import appFetch from '../../../utils/fetch';
import responseCheck from '../../../utils/response-check';

export const verifySpecialAccess = (email: string) => (dispatch: Dispatch, getState: () => IState) => {
    dispatch({ type: VERIFY_SPECIAL_ACCESS_REQUEST });

    const requestUrl = `${config.api.url}${config.api.routes.specialaccess}?email=${email}`;

    return appFetch(getState)(requestUrl)
        .then(responseCheck)
        .then((response) => dispatch(verifySpecialAccessSuccess(response)))
        .catch((error) => dispatch(verifySpecialAccessSuccess(error)));
};

export const editEmail = (email: string) => (dispatch: Dispatch) => {
    dispatch({
        type: EDIT_EMAIL,
        email,
    });
};

export const resetSpecialAccessState = () => (dispatch: Dispatch) => {
    dispatch({
        type: RESET,
    });
};

export const verifySpecialAccessSuccess = (response: any) => ({
    type: VERIFY_SPECIAL_ACCESS_SUCCESS,
    accessData: response ? response.data : null,
});

export const verifySpecialAccessFailure = (error: Error) => ({
    type: VERIFY_SPECIAL_ACCESS_FAILURE,
    error,
});
